import { Box } from '@mui/material';
import React, { ReactElement } from 'react';

export interface PageTabPanelProps{
  panels: ReactElement[];
  tabValue: number;
}

export default function PageTabPanel({panels, tabValue}: PageTabPanelProps){
  // const { } = usePageTabPanel();
  return (
    <div  data-testid='pageTabPanel-render-test'>
      <Box>
        {panels[tabValue]}
      </Box>
    </div>
  )
}
